<template>
<div class="chapter">
<div class="inner_page">
<p class="p1"><span class="t2">Readers Love</span><span class="t3"> </span><span class="t4">Andrew Grey</span></p>
<p class="p2"><span class="t5">A Heart Without Borders</span></p>
<p class="p3">“I felt like I was right there with the characters, feeling the heat, the desperation and the total devastation right along with them. There is no doubt in my mind that this book will stay with me for a long time.”</p>
<p class="p4">—The Novel Approach</p>
<p class="p3">“In true Andrew Grey fashion, this book delivers not only a romance but a powerful lesson on the courage, hope and optimism of people in a country devastated by disaster and poverty.”</p>
<p class="p4">—Hearts on Fire Reviews</p>
<p class="p2"><span class="t5">Stranded</span></p>
<p class="p3">“A great story of how time passes and people allow their relationship to settle into routine and they lose their appreciation for their partner. This doesn’t mean that they are no longer deeply in love, sometimes they just need a reminder.”</p>
<p class="p4">—Gay List Book Reviews</p>
<p class="p3">“<span class="t6">Stranded</span> is an amazing combination between an intense thriller-like stalker story, a sizzling romance, and a character study which, through tension and drama, brings out the worst and the best in both main characters.”</p>
<p class="p4">—Rainbow Book Reviews</p>
<p class="p2"><span class="t5">A Daring Ride</span></p>
<p class="p3">“All the things we’ve come to love from Grey are there in the print. An emotional, engrossing, and sexy ride is what’s in store with this latest work from one of the best authors in the genre.”</p>
<p class="p4">—MM Good Book Reviews</p>
<p class="p3">“I quickly got sucked in by the story and the characters. There really is so much substance in the plot and the people… he doesn’t need a lot of extra language to pull you in.”</p>
<p class="p5">—Mrs. Condit &amp; Friends Read Books</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?5cc2ab4c